var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register"},[_c('div',{staticClass:"box"},[_c('register-form')],1),_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require(("@/assets/" + (_vm.$G('@/')) + "index/logo@2x.png")),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }